export function onRouteUpdate({ location, prevLocation }) {
  window.scrollTo(0, 0);
}
